import styles from './SignatureBlocks.scss';

export default (signature) => {
  const { length } = signature;
  if (length > 12 && length < 18) {
    return styles.signatureSmall;
  }
  if (length >= 18) {
    return styles.signatureTiny;
  }
  return styles.signatureLarge;
};



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/SignatureBlocks/SignatureBlockSizeClass.js